import React from 'react';
import { Copy } from 'lucide-react';
import { ShareButton } from './ShareButton';
import { getShareLinks } from './shareLinks';
import { useToast } from '../../hooks/useToast';

interface ShareButtonsProps {
  pollUrl: string;
  pollName: string;
  shareText?: string;
}

export function ShareButtons({ pollUrl, pollName, shareText }: ShareButtonsProps) {
  const { showToast } = useToast();
  const shareLinks = getShareLinks(pollUrl, pollName, shareText);

  const handleCopyUrl = async () => {
    try {
      await navigator.clipboard.writeText(pollUrl);
      showToast('URL copied to clipboard!');
    } catch (error) {
      showToast('Failed to copy URL. Please try again.');
    }
  };

  return (
    <div className="flex flex-wrap items-center gap-3 justify-center mb-8">
      {shareLinks.map((link) => (
        <ShareButton key={link.name} link={link} />
      ))}
      <button
        onClick={handleCopyUrl}
        title="Copy URL"
        className="p-3 bg-white rounded-lg shadow-sm hover:shadow-md transition-shadow flex items-center justify-center"
      >
        <Copy className="w-5 h-5" />
      </button>
    </div>
  );
}